/**
 * Utility function to determine if the running application is running in the DEVL or PROD
 * environment. The passed 'urlPath' parameter should be captured by the app by the global window
 * object to pass the window.location of their running app to the setEnvPath
 * function to return a valid environment path for AJAX calls.
 *
 * @param {string} urlPath - URL path of running application
 * @return - DEVL/PROD hostname path or empty string if parameter dooesn't
 *  match environment
 */
const setEnvPath = urlPath => {
  const DEV_ENV_PATH = 'integ.apps.devjones.com';
  const PROD_ENV_PATH = 'apps.edwardjones.com';

  // URL represents the app URL
  let appUrl = urlPath;

  // Boolean checks against appUrl to check if app is in DEVL or PROD
  const isDev = /integ.apps.devjones.com/.test(appUrl);
  const isProd = /apps.edwardjones.com/.test(appUrl);

  // Checks if app is in DEVL or PROD, if so, returns the appropriate ENV path
  if (isDev === true || isProd === true) {
    appUrl = isDev ? DEV_ENV_PATH : PROD_ENV_PATH;
    return appUrl;
  }

  // Returns an empty string if DEVL/PROD checks don't pass
  return '';
};
export default setEnvPath;
//# sourceMappingURL=setEnvPath.js.map